<template>
  <a-card :bordered="false">
    <a-button
      type="block"
      class="dashed-button"
      style="height: 34px"
      @click="addFqaDictData">添加数据
    </a-button>
    <div>
      <div :key="row.id" v-for="row in table.data">
        <div class="detail-item-wrap">
          <div class="detail-type">
            <div class="detail-operation">
              <i
                class="fa fa-pencil-square-o"
                 aria-hidden="true"
                 @click="editFqaDictData(row.id)"></i>
              <i
                class="fa fa-times"
                 aria-hidden="true"
                 @click="deleteFqaDictData(row.id)"
              ></i>
            </div>
          </div>
          <div>{{ row.detail }}</div>
        </div>
        <div class="detail-item-wrap">
          <div class="detail-type">
            <div class="detail-operation">
              <i
                class="fa fa-pencil-square-o"
                aria-hidden="true"
                @click="editFqaDictData(row.id)"></i>
              <i
                class="fa fa-times"
                aria-hidden="true"
                @click="deleteFqaDictData(row.id)"
              ></i>
            </div>
          </div>
          <div>{{ row.detailEn }}</div>
        </div>
      </div>
    </div>
    <a-modal
      :footer="null"
             title="提示"
             append-to-body
             v-model="form.visible">
      <fqaDictData-edit
        v-if="form.visible"
        :fqa-dict-id="fqaDictId"
        :fqa-dict-data-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </fqaDictData-edit>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _queryFqaDictData,
  _deleteFqaDictData,
  _upFqaDictData,
  _downFqaDictData,
} from '@/api/fqaDictDataApi';
import FqaDictDataEdit from './FqaDictDataEdit.vue';

async function getFqaDictDataList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryFqaDictData(
    this.fqaDictId,
    {
      sort: 'sort',
      direction,
    },
  );
  this.table.data = result.content;
}

function addFqaDictData() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editFqaDictData(fqaDictDataId) {
  this.form.data.id = fqaDictDataId;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getFqaDictDataList();
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

function onUpdate() {
  // this.form.disabled = true;
  // this.$refs.form.validate(async (valid) => {
  //   if (valid) {
  //     const result = await _updateFqaDict(this.fqaDictId, {
  //       name: this.form.data.name,
  //       code: this.form.data.code,
  //       isActive: this.form.data.isActive,
  //       remark: this.form.data.remark,
  //     });
  //     if (result) {
  //       if (this.onSubmitHandler) {
  //         this.$message.success(this.$t('UPDATE_SUCCESS'));
  //         if (this.onSubmitHandler) {
  //           this.onSubmitHandler();
  //         }
  //       }
  //     }
  //   } else {
  //     this.form.disabled = false;
  //   }
  // });
}

async function deleteFqaDictData(fqaDictDataId) {
  this.$confirm({
    title: this.$t('CONFIRM_REMOVE'),
    content: '',
    onOk: async () => {
      const result = await _deleteFqaDictData(this.fqaDictId, fqaDictDataId);
      if (result) {
        this.$message.success(this.$t('REMOVE_SUCCESS'));
        this.getFqaDictDataList();
      }
    },
  });
}

async function upFqaDictData(fqaDictDataId) {
  this.$confirm({
    title: '是否上移菜单？',
    content: '',
    onOk: async () => {
      await _upFqaDictData(this.fqaDictId, fqaDictDataId);
      this.$message.success('上移成功');
      this.getFqaDictDataList();
    },
  });
}

async function downFqaDictData(fqaDictDataId) {
  this.$confirm({
    title: '是否下移菜单？',
    content: '',
    onOk: async () => {
      await _downFqaDictData(this.fqaDictId, fqaDictDataId);
      this.$message.success('下移成功');
      this.getFqaDictDataList();
    },
  });
}

export default {
  name: 'FqaDictDataList',
  components: { FqaDictDataEdit },
  props: {
    fqaDictId: String,
  },
  data() {
    return {
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'sort',
          order: 'ascend',
        },
      },
    };
  },
  methods: {
    getFqaDictDataList,
    deleteFqaDictData,
    editFqaDictData,
    addFqaDictData,
    closeForm,
    upFqaDictData,
    downFqaDictData,
    onCancel,
    onUpdate,
  },
  created() {
    this.getFqaDictDataList();
  },
};
</script>

<style scoped>
.detail-item-wrap {
  border: 1px solid #eeeeee;
  border-left: 3px solid #2f4669;
  padding: 10px;
  line-height: 20px;
  color: #909399;
  margin: 10px 0;
}

.detail-operation {
  display: none;
  float: right;
  padding-right: 5px;
}

.detail-item-wrap:hover .detail-operation {
  display: block;
}

.detail-operation i {
  cursor: pointer;
  padding: 0 5px;
  font-size: 14px;
  color: #2f4669;
}

.detail-type {
  border-bottom: 1px solid #eeeeee;
  color: #000000;
}
</style>
